import { TableUIProvider } from "../../contexts/TableUIContext";
import Transactions from "./Transactions";

export default function TransactionsWrapper() {
    return (
        <TableUIProvider>
            <Transactions />
        </TableUIProvider>
    );
}
